__turbopack_context__.v({
  "action": "toast-module__eiL02G__action",
  "actions": "toast-module__eiL02G__actions",
  "body": "toast-module__eiL02G__body",
  "close": "toast-module__eiL02G__close",
  "container": "toast-module__eiL02G__container",
  "error": "toast-module__eiL02G__error",
  "icon": "toast-module__eiL02G__icon",
  "info": "toast-module__eiL02G__info",
  "message": "toast-module__eiL02G__message",
  "slideIn": "toast-module__eiL02G__slideIn",
  "success": "toast-module__eiL02G__success",
  "title": "toast-module__eiL02G__title",
  "toast": "toast-module__eiL02G__toast",
  "warning": "toast-module__eiL02G__warning",
});
